import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { useStylesDescription } from './styles';

export const points = [
  'Active users are verified and are able to log in and use the application.',
  'Registered cannot use the application. They need to be verified first.',
  'Invited users are not verified and are not registered yet.',
  'Inactive users are suspended and are not able to log in and use the application.',
];

const UserStatusDescriptionCard: React.FC = () => {
  const classes = useStylesDescription();
  return (
    <Box>
      <Typography variant="subtitle2" data-testid="title">
        What do the statuses mean?
      </Typography>
      <ul className={classes.list}>
        {points.map((point, index) => (
          <li className={classes.listItem} key={`descr-item-${index}`}>
            <Typography variant="body1">{point}</Typography>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default UserStatusDescriptionCard;
